// extracted by mini-css-extract-plugin
export default {"SentTabContainer":"SentTab_SentTabContainer__B7cux","dataContainer":"SentTab_dataContainer__V1Td8","optionsIcon":"SentTab_optionsIcon__TbHWt","openRate":"SentTab_openRate__R57N5"};